import React from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { Media, MediaContextProvider } from "../../../media";


function QualityManagementSystem(props) {
  // const { t } = useTranslation(["translation", "aboutUs"]);

  return (
    <>
      <Helmet>
        <title>Quality Management System | Lussopack</title>
        <meta name="description" content="Quality Management System | Lussopack" />
        <meta name="keywords" content="Quality Management System | Lussopack" />
        <link rel="canonical" href="https://lussopack.com/about-us/" />  
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Quality Management System"}
        textSubHeader={"Our QMS is a beautiful tapestry of processes and procedures, woven together with the threads of continuous improvement and customer satisfaction."}
        desktopImageUrl={
          "/images/aboutUs/QualityManagementSystem/desktop/Lussopack-qualityManagementSystemCover.webp"
        }
        mobileImageUrl={"/images/aboutUs/QualityManagementSystem/mobile/Lussopack-qualityManagementSystemCover.webp"}
      />

      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="qualityManagement">
            <div className="topContainer">
                <h2>Quality Management System</h2>
                <p>
                Lussopack boasts a robust <b>Quality Management System (QMS)</b> that sets the gold standard in the packaging industry. With the mission to deliver the best to our <b>customers globally,</b> the company’s QMS considerately comprehends every facet of our operations, ensuring that each creation reflects <b>opulence, precision, and flawlessness.</b> From the initial concept to the final product, Lussopack's QMS precisely monitors and controls every stage of production, leveraging cutting-edge technology, artisanal craftsmanship, and stringent quality checkpoints to guarantee the delivery of packaging and displays that transcend mere functionality to become true works of art.
                </p>
                <p>We redefine packaging solutions with an unwavering commitment to quality. Our factory is a testament to our dedication to producing packaging materials that not only meet but exceed industry standards. With the approach to Quality Management System (QMS), we ensure that every product bearing the Lussopack name is synonymous with excellence.</p>
            </div>

            <div className="commitmentContainer">
                <h3>Our Commitment to Quality</h3>
                <div className="textInner">
                  <h4>Precision from the Ground Up:</h4>
                  <p>Our manufacturing process begins with the selection of top-grade raw materials. We source materials from trusted suppliers, adhering to strict quality control standards to guarantee consistency and reliability.</p>
                  <h4>Cutting-Edge Technology:</h4>
                  <p>Lussopack's factory is equipped with the latest in packaging technology. From advanced printing techniques to innovative material handling, our machinery is designed to deliver products of unparalleled quality.</p>
                  <h4>Skilled Workforce:</h4>
                  <p>Our team comprises highly skilled professionals who are passionate about crafting exceptional packaging solutions. Their expertise, combined with ongoing training and development, ensures that each product is meticulously produced.</p>
                </div>
            </div>

            <div className="managementSystemContainer">
                <h3>The Lussopack Quality Management System</h3>
                <div className="textInner">
                  <h4>Stringent Quality Checks:</h4>
                  <p>At every stage of production, our products undergo rigorous quality inspections. From material testing to final product evaluation, we leave no room for compromise. Each batch is meticulously examined for dimensional accuracy, material integrity, and visual aesthetics.</p>
                  <h4>Continuous Improvement Culture:</h4>
                  <p>We believe in evolving with the industry and exceeding customer expectations. Our QMS is designed to foster a culture of continuous improvement, encouraging innovation and embracing new technologies that elevate our products.</p>
                  <h4>Traceability and Accountability:</h4>
                  <p>Lussopack maintains comprehensive records for every batch produced. This allows us to trace each product's journey through the manufacturing process, ensuring accountability and transparency.</p>
                  <h4>Customer Feedback Integration: </h4>
                  <p>We value our customers' input as a vital part of our QMS. Feedback is actively sought and integrated into our processes, allowing us to fine-tune our operations and meet evolving market demands.</p>
                  <h4>Assurance of Quality, Every Time</h4>
                  <p>When you choose Lussopack, you're choosing a partner that takes Quality Management System seriously. We stand behind our products with confidence, knowing that each item leaving our factory represents the pinnacle of packaging excellence.</p>
                </div>
            </div>
            
            <p className="bottomText">Contact us today to discover how Lussopack can transform your packaging needs!</p>

            <div className="imgContainer">
              <Image
                  src={asset("/images/aboutUs/QualityManagementSystem/desktop/Lussopack-qualityManagementSystem.webp")}
                  alt="qualityManagementSystem"
                  className="img-fluid"
                  width="1240"
                  heigth="800"
              />   
            </div>
          </div>
        </Media>
        <Media lessThan="md">
          <div id="qualityManagementMobile">
            <div className="topContainer">
                <h2>Quality Management System</h2>
                <p>
                Lussopack boasts a robust <b>Quality Management System (QMS)</b> that sets the gold standard in the packaging industry. With the mission to deliver the best to our <b>customers globally,</b> the company’s QMS considerately comprehends every facet of our operations, ensuring that each creation reflects <b>opulence, precision, and flawlessness.</b> From the initial concept to the final product, Lussopack's QMS precisely monitors and controls every stage of production, leveraging cutting-edge technology, artisanal craftsmanship, and stringent quality checkpoints to guarantee the delivery of packaging and displays that transcend mere functionality to become true works of art.
                </p>
                <p>We redefine packaging solutions with an unwavering commitment to quality. Our factory is a testament to our dedication to producing packaging materials that not only meet but exceed industry standards. With the approach to Quality Management System (QMS), we ensure that every product bearing the Lussopack name is synonymous with excellence.</p>
            </div>

            <div className="commitmentContainer">
                  <h3>Our Commitment to Quality</h3>              
                  <h4>Precision from the Ground Up:</h4>
                  <p>Our manufacturing process begins with the selection of top-grade raw materials. We source materials from trusted suppliers, adhering to strict quality control standards to guarantee consistency and reliability.</p>
                  <h4>Cutting-Edge Technology:</h4>
                  <p>Lussopack's factory is equipped with the latest in packaging technology. From advanced printing techniques to innovative material handling, our machinery is designed to deliver products of unparalleled quality.</p>
                  <h4>Skilled Workforce:</h4>
                  <p>Our team comprises highly skilled professionals who are passionate about crafting exceptional packaging solutions. Their expertise, combined with ongoing training and development, ensures that each product is meticulously produced.</p>
            </div>

            <div className="managementSystemContainer">
                  <h3>The Lussopack Quality Management System</h3>
                  <h4>Stringent Quality Checks:</h4>
                  <p>At every stage of production, our products undergo rigorous quality inspections. From material testing to final product evaluation, we leave no room for compromise. Each batch is meticulously examined for dimensional accuracy, material integrity, and visual aesthetics.</p>
                  <h4>Continuous Improvement Culture:</h4>
                  <p>We believe in evolving with the industry and exceeding customer expectations. Our QMS is designed to foster a culture of continuous improvement, encouraging innovation and embracing new technologies that elevate our products.</p>
                  <h4>Traceability and Accountability:</h4>
                  <p>Lussopack maintains comprehensive records for every batch produced. This allows us to trace each product's journey through the manufacturing process, ensuring accountability and transparency.</p>
                  <h4>Customer Feedback Integration: </h4>
                  <p>We value our customers' input as a vital part of our QMS. Feedback is actively sought and integrated into our processes, allowing us to fine-tune our operations and meet evolving market demands.</p>
                  <h4>Assurance of Quality, Every Time</h4>
                  <p>When you choose Lussopack, you're choosing a partner that takes Quality Management System seriously. We stand behind our products with confidence, knowing that each item leaving our factory represents the pinnacle of packaging excellence.</p>
            </div>
            
            <p className="bottomText">Contact us today to discover how Lussopack can transform your packaging needs!</p>

              <Image
                  src={asset("/images/aboutUs/QualityManagementSystem/mobile/Lussopack-qualityManagementSystem.webp")}
                  alt="qualityManagementSystem"
                  className="img-fluid"
                  width="100%"
                  heigth="auto"
              />   
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default QualityManagementSystem;
